import React from "react";
import styled from "styled-components";
import { Form as BootstrapForm, Button } from "react-bootstrap";

const FormWrapper = styled.div`
  text-align: left;
  padding: 1rem;
`;

const Form = (props) => {
  return (
    <FormWrapper>
      <BootstrapForm noValidate validated={props.validated} onSubmit={props.onSubmit}>
          <BootstrapForm.Group
            controlId="subscribeFormFirstName"
            className="mb-3"
          >
          <BootstrapForm.Label>First Name</BootstrapForm.Label>
          <BootstrapForm.Control
            type="text"
            name="firstName"
            placeholder="Enter your first name"
            autoComplete="given-name"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide your first name.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <BootstrapForm.Group
          controlId="subscribeFormLastName"
          className="mb-3"
        >
          <BootstrapForm.Label>Last Name</BootstrapForm.Label>
          <BootstrapForm.Control
            type="text"
            name="lastName"
            placeholder="Enter your last name"
            autoComplete="family-name"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide your last name.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <BootstrapForm.Group
          controlId="subscribeFormEmail"
          className="mb-3"
        >
          <BootstrapForm.Label>Email address</BootstrapForm.Label>
          <BootstrapForm.Control
            type="email"
            name="emailAddress"
            placeholder="Enter your email address"
            autoComplete="email"
            onChange={props.onChange}
            required
          />
          <BootstrapForm.Text className="text-muted">
            Your information will only be used for Aspiricity updates and communications.
          </BootstrapForm.Text>
          <BootstrapForm.Control.Feedback type="invalid">
            Please provide a valid email address.
          </BootstrapForm.Control.Feedback>
        </BootstrapForm.Group>
        <div className="mt-3">
          <Button variant="primary" type="submit" className="me-2">
            Subscribe
          </Button>

          <Button variant="secondary" type="reset">
            Reset Form
          </Button>
        </div>
      </BootstrapForm>
        {props.title && <h2>{props.title}</h2>}
        {props.children}
    </FormWrapper>
  );
};

export default Form;
